//  NavigationBar.js
//
//  Updated 3/4.
//
//  Abstract: Navigation bar.

//	React
import React, { useEffect } from 'react';
import { Switch, Link, NavLink, Route } from 'react-router-dom';
//	Material-ui styles
import {
	makeStyles,
	Button,
	Menu,
	MenuItem,
	AppBar,
	Toolbar,
	Hidden,
	IconButton
} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CreateIcon from '@material-ui/icons/Create';
import DoneIcon from '@material-ui/icons/Done';
import HomeIcon from '@material-ui/icons/Home';
import NotesIcon from '@material-ui/icons/Notes';
import MenuIcon from '@material-ui/icons/Menu';
//	CSS styles`
const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	appBar: {
		[theme.breakpoints.up('sm')]: {
			width: `100%`,
			zIndex: '1300'
		},
		backgroundColor: 'transparent !important'
	},
	account: {
		position: 'fixed',
		right: 0
	},
	menuButton: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			display: 'none',
		},
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '15px',
		width: '15px',
		left: '50%',
		top: '35%'
	},
	ListItem: {
		fontSize: 14,
	},
	activeLink: {
		color: 'blue'
	},
	title: {
		justify: 'center',
		paddingLeft: '10%',
		paddingTop: '10%',
		paddingBottom: '10%',
	},
	subtitle: {
		display: 'inline'
	},
	drawerLinks: {
		color: 'black',
	},
}));

export default function NavigationBar(props) {

	const classes = useStyles();

	
		//	Event handlers
		function handleLoadAccountConfiguration(event) {
			// setComponentToRender('AccountConfiguration');
		}
		function handleLogout(event) {
			// Logout
			localStorage.removeItem('AuthToken');
			// history.push('/login');
		}
		const handleClick = (event) => {
			// setAnchorEl(event.currentTarget);
		};
		const handleClose = () => {
			// setAnchorEl(null);
		};

	return (
		<>
			<AppBar position="fixed" variant="outlined" className={classes.appBar} elevation={0}>
				<Toolbar>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						edge="start"
						// onClick={handleDrawerToggle 
						className={classes.menuButton}
					>
						<MenuIcon />
					</IconButton>
					<div className={classes.account}>
						<Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
							<NotificationsIcon color='secondary' />{' '}
						</Button>
						<Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
							<AccountCircleIcon color="secondary" />{' '}
						</Button>
						<Menu
							id="simple-menu"
							// anchorEl={anchorEl}
							keepMounted
							// open={Boolean(anchorEl)}
							onClose={handleClose}
						>
							<MenuItem onClick={handleClose, handleLoadAccountConfiguration}>Settings</MenuItem>
							<MenuItem onClick={handleClose, handleLogout}>Logout</MenuItem>
						</Menu>
					</div>
				</Toolbar>
			</AppBar>
		</>
	);


}
